module.exports = __webpack_public_path__ + "img/chart-brutkar.41b421ee.png";